<template>
<div id="edit-newsletter">
  <newsletter-form
    :newsletterId="newsletterId"
  ></newsletter-form>
</div>
</template>

<script>
import NewsletterForm from '@/components/NewsletterForm'

export default {
  components: {
    'newsletter-form': NewsletterForm
  },

  props: ['newsletterId'],

  methods: {
    processErrors (resp) {
      this.$parent.processErrors(resp)
    }
  },

  watch: {
    '$route' (to, from) {
      this.get()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NewsletterEdit.vue